var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 16.5V32.5H32.5V0.5H0.5V16.5ZM18.0933 8.25067L19.6493 12.9373L22.656 12.944C24.3067 12.9507 26.544 12.9693 27.6253 12.9933L29.588 13.0307L25.6307 15.9C23.4573 17.4747 21.6627 18.8067 21.644 18.8493C21.6307 18.8933 22.2933 21.0187 23.1187 23.5693C23.944 26.1253 24.612 28.2187 24.6067 28.2253C24.6 28.2387 22.8067 26.9627 20.6253 25.4C19.2852 24.4286 17.9371 23.4681 16.5813 22.5187C16.544 22.5053 14.7 23.7813 12.488 25.3693C10.2813 26.9493 8.46133 28.2373 8.456 28.2253C8.45067 28.2187 9.11867 26.1253 9.944 23.5693C10.7693 21.0187 11.4307 18.8933 11.4187 18.8493C11.4 18.8067 9.60533 17.476 7.432 15.9L3.47333 13.0307L5.436 12.9933C6.51733 12.9693 8.756 12.9507 10.4053 12.944L13.4107 12.9373L14.968 8.25067C15.4828 6.68613 16.0032 5.12345 16.5293 3.56267C16.536 3.56267 17.2373 5.66933 18.0933 8.25067Z",
    fill: "#5B4E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverImg);
export default __webpack_public_path__ + "static/media/coverImg.9cc68c7dda18342413636ad7c49dad42.svg";
export { ForwardRef as ReactComponent };